import React from 'react'

import { message, notification } from 'antd'
import * as api from '../services/api'
import { RouteComponentProps } from 'react-router-dom'
import {
  IconType as NotificationIconType,
  ArgsProps as NotificationConfig,
} from 'antd/lib/notification'

/**
 * 扩展组件/store类以方便调用
 * Route 扩展组件
 * 集成api, 公用组件
 */
export class ComponentExt<P = {}, S = {}> extends React.Component<P, S> {
  readonly api = api
  readonly $message = message
  protected $notify = (type: NotificationIconType) => (
    config: NotificationConfig,
  ) => notification[type](config)
}

export class RouteComponentExt<
  P = RouteComponentProps<any>,
  S = {}
> extends React.Component<{}, S> {
  readonly api = api
  readonly $message = message
}

export class StoreExt {
  readonly api = api
  readonly $message = message
}
